import { Input, Image, Text, View, Radio } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface State {
  type: number;
  phone: string;
  name: string;
  password: string;
  editing: boolean;
}

export default class AccountAdd extends Base<any> {
  public config: Config = {
    navigationBarTitleText: '添加账户'
  };

  public state: State = {
    type: 1,
    phone: "",
    name: "",
    password: "",
    editing: false
  };

  public async didMount() {
    if(this.props.location.state && this.props.location.state.id){
      await this.getUserInfo()
      this.setState({
        editing:true,
      })
    }else{
      // console.log("没有id")
    }

  }

  private link = url => {
    history.push(url);
  }

  private valueChange = (name,e) => {
    // console.log(name,[name],name.indexOf('.'),e.target.value);
    this.setState({[name]:  e.target.value})
  }

  private radioFun = (name,index,e) => {
    // console.log(name,index)
    this.setState({[name]:  index})
  }

  private getUserInfo = async() => {
    const res = await this.apiClient.base.userListInfo()
    console.log(res);
    if(res && res.status == 10000){
      this.setState({
        type: res.body.type,
        phone: res.body.phone,
        name: res.body.name,
      })
    }
  }

  private submit = async() => {
    const { type, phone, name, password, editing } = this.state;
    if(editing){
      this.edit()
      return;
    }
    if(phone == '' || name == '' || password == ''){
      toast.error("请填写完整信息",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return;
    }
    if(phone.length != 11){
      toast.error("手机号格式错误",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return;
    }

    const res = await this.apiClient.base.userApi({
      type, phone, name, password
    })
    console.log(res)
    if(res.status == 10000){
      toast.info("提交成功",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      setTimeout(function(){
        history.goBack()
      },1000)
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
    }
    
  }

  private edit = async() => {
    const { type, phone, name } = this.state;
    if(phone == '' || name == ''){
      toast.error("请填写完整信息",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return;
    }
    if(phone.length != 11){
      toast.error("手机号格式错误",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return;
    }

    const res = await this.apiClient.base.userEdit({
      type, phone, name
    })
    console.log(res)
    if(res.status == 10000){
      toast.info("修改成功",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      setTimeout(function(){
        history.goBack()
      },1000)
    }else{
      toast.error(res.msg,{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
    }
  }

  public render() {
    const { type, phone, name, password, editing } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        
        <View className={styles.main}>
          <View className={styles.list}>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>账户身份*</Text>
              <View className={styles.lis_r}>
                <Radio 
                  opt= {[
                    {
                      text:'管理员',
                      ind:1
                    },
                    {
                      text:'销售员',
                      ind:2
                    },
                    {
                      text:'分拣员',
                      ind:3
                    }
                  ]}
                  value = {type}
                  name = "type"
                  onClick={this.radioFun} 
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>姓名</Text>
              <View className={styles.lis_r}>
                <Input
                  value={name}
                  name="name"
                  className={styles.input}
                  placeholder="请填写姓名"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            <View className={styles.lis}>
              <Text className={styles.lis_l}>手机号/账号</Text>
              <View className={styles.lis_r}>
                <Input
                  value={phone}
                  name="phone"
                  type="number"
                  className={styles.input}
                  placeholder="请填写手机号"
                  valueChange={this.valueChange}
                />
              </View>
            </View>
            {!editing && (
              <View className={styles.lis}>
                <Text className={styles.lis_l}>密码</Text>
                <View className={styles.lis_r}>
                  <Input
                    value={password}
                    name="password"
                    className={styles.input}
                    placeholder="请填写初始密码"
                    valueChange={this.valueChange}
                  />
                </View>
              </View>
            )}
            
          </View>
          <View className={styles.buttonBox}>
              <Text className={styles.adminBtn} onClick={this.submit}>
                {editing?'提交修改':'添加账户'}
              </Text>
          </View>
        </View>
        
      </View>
    );
  }
}
